
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "16px",
    "height": "11px",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M 0.866666666666667 1.46627027027027  C 0.498476833446138 1.46627027027027  0.2 1.20006120260209  0.2 0.871675675675676  C 0.2 0.543290148749258  0.498476833446138 0.277081081081081  0.866666666666667 0.277081081081081  L 15.0893333333333 0.277081081081081  C 15.4575231665539 0.277081081081082  15.756 0.543290148749259  15.756 0.871675675675676  C 15.756 1.20006120260209  15.4575231665539 1.46627027027027  15.0893333333333 1.46627027027027  L 0.866666666666667 1.46627027027027  Z M 0.866666666666667 6.22302702702703  C 0.498476833446138 6.22302702702703  0.2 5.95681795935885  0.2 5.62843243243243  C 0.2 5.30004690550601  0.498476833446138 5.03383783783784  0.866666666666667 5  L 15.0893333333333 5  L 15.0893333333333 5.03383783783784  C 15.4575231665539 5.03383783783784  15.756 5.30004690550602  15.756 5.62843243243243  C 15.756 5.95681795935885  15.4575231665539 6.22302702702703  15.0893333333333 6.22302702702703  L 0.866666666666667 6.22302702702703  Z M 15.0893333333333 9.7905945945946  L 0.866666666666667 9.7905945945946  C 0.498476833446138 9.7905945945946  0.2 10.0568036622628  0.2 10.3851891891892  C 0.2 10.7135747161156  0.498476833446138 10.9797837837838  0.866666666666667 10.9797837837838  C 0.866666666666667 10.9797837837838  0.866666666666667 10.9797837837838  0.866666666666667 11  L 15.0893333333333 11  C 15.0893333333333 10.9797837837838  15.0893333333333 10.9797837837838  15.0893333333333 10.9797837837838  C 15.4575231665539 10.9797837837838  15.756 10.7135747161156  15.756 10.3851891891892  C 15.756 10.0568036622628  15.4575231665539 9.7905945945946  15.0893333333333 9.7905945945946  Z ",
            "fill-rule": "nonzero",
            "fill": "#333333",
            "stroke": "none"
          }
        }
      ]
    }
  ]
})
    }
  